export default __webpack_public_path__ + "static/media/time.0c188f71.svg";